import { IMG } from "@/lib/brand";
import { PageHero, Reveal, SectionEyebrow } from "@/components/Section";
import { HexWatermark } from "@/components/BrandMark";
import { useLang } from "@/lib/LanguageContext";

const SECTOR_IMAGES = [IMG.industrial1, IMG.texture2, IMG.industrial2, IMG.wood, IMG.machinery, IMG.printing];

export default function Industries() {
  const { t } = useLang();
  const i = t.industries;

  return (
    <div data-testid="industries-page" className="bg-white">
      <PageHero
        testId="industries-hero"
        eyebrow={i.hero_eyebrow}
        title={i.hero_title}
        intro={i.hero_intro}
        image={IMG.industrial2}
      />

      <section className="container-x py-24 sm:py-32 space-y-px">
        {i.items.map((it, idx) => (
          <Reveal key={idx}>
            <article
              data-testid={`industry-row-${idx}`}
              className={`grid lg:grid-cols-12 gap-10 items-center border-b border-border py-16 ${
                idx % 2 === 1 ? "lg:[&>*:first-child]:order-2" : ""
              }`}
            >
              <div className="lg:col-span-7 img-zoom border border-border aspect-[16/10]">
                <img src={SECTOR_IMAGES[idx]} alt={it.name} className="w-full h-full object-cover" />
              </div>
              <div className="lg:col-span-5">
                <span className="text-[11px] tabular-nums tracking-[0.22em] uppercase text-muted-foreground">
                  {i.sector_label} · 0{idx + 1}
                </span>
                <h2 className="mt-4 font-display text-3xl sm:text-4xl tracking-tight font-medium leading-[1.05]">{it.name}</h2>
                <p className="mt-5 text-muted-foreground leading-relaxed">{it.intro}</p>
                <ul className="mt-7 space-y-2">
                  {it.bullets.map((b) => (
                    <li key={b} className="text-sm text-primary flex gap-3 items-start">
                      <span className="text-accent mt-1">▍</span>
                      {b}
                    </li>
                  ))}
                </ul>
              </div>
            </article>
          </Reveal>
        ))}
      </section>

      <section className="relative bg-secondary border-y border-border overflow-hidden">
        <HexWatermark
          opacity={0.05}
          size={580}
          strokeWidth={1.2}
          className="text-primary left-1/2 -translate-x-1/2 top-1/2 -translate-y-1/2"
        />
        <div className="relative container-x py-20 sm:py-28 text-center">
          <SectionEyebrow>{i.bottom_eyebrow}</SectionEyebrow>
          <h3 className="mt-5 font-display text-3xl sm:text-5xl tracking-tight font-medium leading-[1.05] max-w-3xl mx-auto">
            {i.bottom_title}
          </h3>
        </div>
      </section>
    </div>
  );
}
